/**
 * Image delivery helpers.
 *
 * The book covers live on the project CDN as large PNGs (1024×1536, ~1.2 MB
 * each) and the page only ever displays them a few hundred pixels wide. They
 * are routed through wsrv.nl, which re-encodes them to WebP at the requested
 * width, so mobile downloads ~40–120 KB instead of megabytes.
 *
 * Every consumer falls back to the original URL if the resizer fails, so the
 * page never renders a broken image.
 */
const RESIZER = 'https://images.weserv.nl/'

export const COVER_WIDTHS = [320, 480, 720, 1000] as const

/** Matches how covers are laid out: fluid on mobile, ~300px on desktop. */
export const COVER_SIZES = '(max-width: 640px) 45vw, 300px'

export function optimizedImage(src: string, width: number): string {
  if (!/^https?:\/\//i.test(src)) return src
  const params = new URLSearchParams({
    url: src.replace(/^https?:\/\//i, ''),
    w: String(width),
    output: 'webp',
    q: '80'
  })
  return `${RESIZER}?${params.toString()}&we`
}

export function coverSrc(src: string): string {
  return optimizedImage(src, 720)
}

export function coverSrcSet(src: string): string {
  return COVER_WIDTHS.map(width => `${optimizedImage(src, width)} ${width}w`).join(', ')
}
